export default __webpack_public_path__ + "static/doccam_w.55e2585fce45d4cf19c2f1614250777c.svg";